import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EDMUNDS_LOGO_NO_TEXT } from 'client/images/inline-svgs/edmunds-logo';
import { CANVAS_ICONS } from 'site-modules/canvas/constants/canvas';

import './canvas-loader.scss';

export function CanvasLoader({ width = 20, className = null, withSparkle = false }) {
  return (
    <div className={classnames('canvas-loader pos-r', className)}>
      <div className="loader pos-r" style={{ width: `${width * 2}px`, height: `${width * 2}px` }} />
      {withSparkle ? (
        <div className="canvas-loader-logo pos-a center-xy" style={{ width: `${width}px`, height: `${width}px` }}>
          <EDMUNDS_LOGO_NO_TEXT width={width} />
          <img
            className="sparkle pos-a"
            src={CANVAS_ICONS.RED_SPARKLE}
            width={13}
            height={13}
            alt="Ask AI"
            loading="lazy"
          />
        </div>
      ) : (
        <EDMUNDS_LOGO_NO_TEXT width={width} classes="pos-a center-xy" />
      )}
    </div>
  );
}

CanvasLoader.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  withSparkle: PropTypes.bool,
};
